// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const UserPropertiesActions = Marty.createActionCreators({
  updateProperties(userId, properties, notificationMessage) {
    return this.app.queries.UserPropertiesQueries.updateProperties(userId, properties, notificationMessage)
  }
})

export default UserPropertiesActions



// WEBPACK FOOTER //
// ./src/scripts/actions/UserPropertiesActions.js